import React from 'react';
import { useTranslation } from 'react-i18next';
import { createCn } from '../../helpers/utils';
import classes from './styles.module.scss';
import { useAuth } from '../../contexts/auth.context';
import MyVoiceSection from './components/my-voice-section.component';

const cn = createCn('profile', classes);

/** Человекочитаемые роли (задача SP1). Отдельного словаря ролей в i18n пока нет —
 *  единственное другое место, что читает user.role, это RequireAdmin (без лейбла). */
const ROLE_LABELS: Record<string, string> = {
  admin: 'Администратор',
  manager: 'Менеджер',
  team_member: 'Участник команды',
  viewer: 'Наблюдатель',
  user: 'Пользователь',
};

const ProfilePage = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const displayName = user?.full_name || user?.email?.split('@')[0] || t('profile.no-name');
  const avatarLetter = displayName.charAt(0).toUpperCase();
  const roleLabel = user?.role ? (ROLE_LABELS[user.role] ?? user.role) : '';

  return (
    <div className={cn('')}>
      <div className={cn('heading')}>{t('profile.heading')}</div>

      <div className={cn('content')}>
        <div className={cn('user-card')}>
          <div className={cn('user-avatar')} aria-hidden="true">{avatarLetter}</div>
          <div className={cn('user-info')}>
            <div className={cn('user-name')}>{displayName}</div>
            {user?.email && <div className={cn('user-email')}>{user.email}</div>}
            {roleLabel && <div className={cn('user-role')}>{roleLabel}</div>}
          </div>
        </div>

        <section className={cn('section')} aria-labelledby="profile-voice-heading">
          <h2 id="profile-voice-heading" className={cn('section-title')}>
            {t('profile.voice-title')}
          </h2>
          <MyVoiceSection />
        </section>
      </div>
    </div>
  );
};

export default ProfilePage;
